import React, {Component} from 'react';

import SeychellesGallery from './SeychellesGallery';

class SeychellesGalleryContainer extends Component {
    render() {
        return(
            <SeychellesGallery/>
        )
    }
}

export default SeychellesGalleryContainer;



// WEBPACK FOOTER //
// ./src/pages/gallery/seychelles/SeychellesGalleryContainer.jsx